import { GET, GET_CLAIM_FULL_SEARCH } from '../../../../services';
import { useMutation } from '@tanstack/react-query';
import { useState } from 'react';

export const useGetClaimFull = ({ handleSubmit }) => {
  const [data, setData] = useState([]);

  const { isPending, mutate: onSearchFull } = useMutation({
    mutationFn: async (searchParamState) => {
      // ค้นด้วยข้อความต้องเจอทุกสถานะ ไม่ส่ง claimStatus จากฟอร์ม (ค่า default คือ WAIT)
      const { search } = searchParamState;
      const response = await GET(
        GET_CLAIM_FULL_SEARCH({
          search: search || '',
        }),
      );
      return response.result.items || [];
    },
    onSuccess: (response) => {
      setData(response);
    },
  });

  const onFetchFull = () =>
    handleSubmit((values) => {
      return onSearchFull(values);
    })();

  return { dataSource: data, setData, onSearchFull, loading: isPending, onFetchFull };
};
